import { render } from "./attach-icon.vue?vue&type=template&id=0ab49750"
import script from "./attach-icon.vue?vue&type=script&lang=js"
export * from "./attach-icon.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__